module.exports = __webpack_public_path__ + "static/media/calendarIcon.d583577b.svg";